<div class="flip-container flip-horizontal" [class.open]="toggle.price"  [style.height.px]="cardMinHeight">
  <div class="flipper">
    <div class="card front overflow" #frontCard [attr.aria-hidden]="toggle.price">
       <table>
        <thead>
        <tr>
          <th class="sr-only" [innerHTML]="textkeyPrefix + '.wirtschaftlichkeit.table.kosten.einnahmen' | translate"></th>
          <th [innerHTML]="textkeyPrefix + '.wirtschaftlichkeit.table.laufzeit' | translate"></th>
          <th [innerHTML]="textkeyPrefix + '.wirtschaftlichkeit.table.laufzeitende' | translate"></th>
        </tr>
        </thead>
        <tbody>
        <tr class="highlight">
          <th>
            {{ textkeyPrefix + '.wirtschaftlichkeit.table.kosten.jaehrlich' | translate }}
            <button class="help-button" type="button" [attr.aria-label]="'arialabel.toggle.help' | translate" [title]="textkeyPrefix + '.hilfe' | translate" (click)="flipInfo('helpCost')"><i class="icon-help-circle"></i></button>
          </th>
          <td>{{ placeholder.kosten_laufzeit }} €</td>
          <td>{{ placeholder.kosten_laufzeitende }} €</td>
        </tr>
          @if (toggle.helpCost) {
            <tr class="help">
              <td colspan="3">
                <app-photovoltaikcheck-ergebnis-help [textkeyprefix]="textkeyPrefix" topic="wirtschaftlichkeit.table.kosten" (close)="flipInfo('helpCost')"></app-photovoltaikcheck-ergebnis-help>
              </td>
            </tr>
          }
          @if (placeholder.belastung_kredit_plain) {
            <tr>
              <th>{{ textkeyPrefix + '.wirtschaftlichkeit.table.kosten.kredit' | translate }}</th>
              <td>{{ placeholder.belastung_kredit }} €</td>
              <td>- €</td>
            </tr>
          }
          @if (placeholder.belastung_abschreibung_plain) {
            <tr>
              <th>{{ textkeyPrefix + '.wirtschaftlichkeit.table.kosten.abschreibung' | translate }}</th>
              <td>{{ placeholder.belastung_abschreibung }} €</td>
              <td>- €</td>
            </tr>
          }
        <tr>
          <th (click)="flipInfo('maintenance')">
            {{ textkeyPrefix + '.wirtschaftlichkeit.table.kosten.betrieb' | translate }}
            <button class="chevron" [attr.aria-label]="textkeyPrefix + '.wirtschaftlichkeit.table.kosten.betrieb' | translate" [tabindex]="toggle.price? '-1' : '0'"><i class="icon-chevron-down" [class.rotate]="toggle.maintenance"></i></button>
          </th>
          <td>{{ placeholder.betriebskosten_gesamt }} €</td>
          <td>{{ placeholder.betriebskosten_gesamt }} €</td>
        </tr>
          @if (toggle.maintenance) {
            @for(cost of ['reinigung', 'versicherung', 'wartung']; track cost) {
              <tr class="intent">
                <th>
                  {{ textkeyPrefix + '.wirtschaftlichkeit.table.kosten.betrieb.' + cost | translate }}
                </th>
                <td>{{ placeholder['betriebskosten_' + cost] }} €</td>
                <td>{{ placeholder['betriebskosten_' + cost] }} €</td>
              </tr>
            }
          }
        <tr class="highlight">
          <th>
            {{ textkeyPrefix + '.wirtschaftlichkeit.table.einsparung.jaehrlich' | translate }}
            <button class="help-button" (click)="flipInfo('helpSaving')"  [attr.aria-label]="'arialabel.toggle.help' | translate" [tabindex]="toggle.price? '-1' : '0'" [title]="textkeyPrefix + '.hilfe' | translate"><i class="icon-help-circle"></i></button>
          </th>
          <td>{{ placeholder.einsparungen_laufzeit }} €</td>
          <td>{{ placeholder.einsparungen_laufzeitende }} €</td>
        </tr>
          @if (toggle.helpSaving) {
            <tr class="help">
              <td colspan="3">
                <app-photovoltaikcheck-ergebnis-help [textkeyprefix]="textkeyPrefix" topic="wirtschaftlichkeit.table.einsparung" (close)="flipInfo('helpSaving')"></app-photovoltaikcheck-ergebnis-help>
              </td>
            </tr>
          }
          @if(placeholder.einsparung_stromzukauf_laufzeit_plain) {
            <tr>
              <th>
                {{ textkeyPrefix + '.wirtschaftlichkeit.table.einsparung.strom' | translate }}
                <button class="edit-button"
                  [tabindex]="toggle.price? '-1' : '0'"
                  (click)="flipInfo('price')"
                >
                  <i class="icon-edit-3"></i>
                  {{ textkeyPrefix + '.wirtschaftlichkeit.table.einsparung.strompreis.edit' | translate }}
                </button>
              </th>
              <td>{{ placeholder.einsparung_stromzukauf_laufzeit }} €</td>
              <td>{{ placeholder.einsparung_stromzukauf_laufzeit }} €</td>
            </tr>
          }
        <tr>
          <th>{{ textkeyPrefix + '.wirtschaftlichkeit.table.einsparung.einspeisung' | translate }}</th>
          <td>{{ placeholder.einspeiseverguetung_laufzeit }} €</td>
          <td>- €</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th>{{ textkeyPrefix + '.wirtschaftlichkeit.table.bilanz' | translate }}</th>
          <td>{{ placeholder.kostenbilanz_laufzeit }} €</td>
          <td>{{ placeholder.kostenbilanz_laufzeitende }} €</td>
        </tr>
        </tfoot>
        <caption class="caption" #frontCardCaption [innerHTML]="textkeyPrefix + '.wirtschaftlichkeit.table.fazit.' + ratings.wirtschaftlichkeit_bilanz | translate: placeholder"></caption>
    </table>
    </div>
    <div class="card back" #backCard [attr.aria-hidden]="!toggle.price">
      <app-photovoltaikcheck-ergebnis-price
        [textkeyPrefix]="textkeyPrefix"
        [anfrage]="anfrage"
        [loading]="toggle.loading"
        [isHidden]="!toggle.price"
        (close)="flipInfo('price')"
        (save)="saveForm($event)"
      ></app-photovoltaikcheck-ergebnis-price>
    </div>
  </div>
</div>
